var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "router-link",
    { staticClass: "search-result", attrs: { to: _vm.link } },
    [
      _c(
        "div",
        {
          staticClass: "search-result__column",
          attrs: { "data-column": "name", "data-title": "Name" },
        },
        [
          _c("span", { staticClass: "user" }, [
            _vm.resource.avatar
              ? _c("img", {
                  staticClass: "avatar avatar--small",
                  attrs: {
                    src: _vm.resource.avatar.url,
                    title: _vm.resource.unformatted_name,
                    alt: `${_vm.resource.unformatted_name}'s avatar`,
                    width: "32",
                    height: "32",
                  },
                })
              : _c("img", {
                  staticClass: "avatar avatar--small",
                  attrs: {
                    src: "//placehold.it/32x32",
                    width: "32",
                    height: "32",
                    alt: "",
                  },
                }),
            _vm._v(" "),
            _c("span", {
              staticClass: "name",
              domProps: { innerHTML: _vm._s(_vm.resource.name) },
            }),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "search-result__column",
          attrs: { "data-column": "company", "data-title": "Company" },
        },
        [_c("span", { domProps: { textContent: _vm._s(_vm.resource.member) } })]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "search-result__column",
          attrs: { "data-column": "location", "data-title": "Location" },
        },
        [
          _c("span", {
            domProps: { textContent: _vm._s(_vm.resource.location) },
          }),
        ]
      ),
      _vm._v(" "),
      _vm.resource.sectors && _vm.resource.sectors.length > 0
        ? _c(
            "div",
            {
              staticClass: "search-result__column",
              attrs: { "data-column": "sector", "data-title": "Sector" },
            },
            _vm._l(_vm.resource.sectors, function (sector) {
              return _c("span", { staticClass: "sector" }, [
                _vm._v(_vm._s(sector.name)),
              ])
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }